import React, { Fragment, useState, useEffect } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

import q1 from '../../images/handicap-center-visit/1.webp'
import q2 from '../../images/handicap-center-visit/2.webp'
import q3 from '../../images/handicap-center-visit/3.webp'
import q4 from '../../images/handicap-center-visit/4.webp'
import q5 from '../../images/handicap-center-visit/5.webp'
import q7 from '../../images/handicap-center-visit/7.webp'

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";
import { Helmet } from 'react-helmet';

const HandicapCenterVisit = ({ path }) => {

    // Setting metadata and schemadata 
    const [metadata, setMetadata] = useState({title: "JJFIndia | Our Initiative"});
    const [schemadata, setSchemadata] = useState({});
    
    // Getting the schemadata and setting the schema data. 
    useEffect(() => {
        let tempMetadata = metadataJSON[path];
        let tempSchemadata = schemadataJSON[path];

        if(tempMetadata){
        setMetadata(tempMetadata);
        }else {
        tempMetadata = {
            title: "JJFIndia | Gallery",
            description: "JJFIndia Gallery page",
            keywords: "",
            robots: "index, follow",
            canonical: "https://jjfindia.com/gallery/tree-plantation",
            openGraph: {
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page",
                url: "https://jjfindia.com/gallery/tree-plantation"
            },
            twitter: {
                card: "summary_large_image",
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page"
            }
        }

        setMetadata(tempMetadata);
        }

        // setting schema data 
        if(tempSchemadata) {
            setSchemadata(tempSchemadata);
        }

    }, [path]);

    return (
        <>

            <Helmet>
                {/* Basic Meta Tags */}
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <meta name="robots" content={metadata.robots} />
        
                {/* Canonical URL */}
                <link rel="canonical" href={metadata.canonical} />
        
                {/* Open Graph */}
                <meta property="og:title" content={metadata.openGraph?.title} />
                <meta property="og:description" content={metadata.openGraph?.description} />
                <meta property="og:url" content={metadata.canonical} />
        
                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content={metadata.twitter?.title} />
                <meta name="twitter:description" content={metadata.twitter?.description} />
                
                {/* Setting up schema data */}
                <script  type="application/ld+json" >{JSON.stringify(schemadata, null, 2)}</script>
            </Helmet>

            <Fragment>
                <Header hclass={'header--styleFour'} />
                <main className="page_content">
                    <PageTitle pageTitle={'Handicap Center Visit'} pagesub={'Gallery'} />


                    <section className="blog pt-60">
                        <div className="container">
                            <div className="row align-items-end">
                                <div className="col-12">
                                    <div className="sectionTitle mb-40" id='feature'>
                                        <span className="sectionTitle__small justify-content-center">
                                            <i className="fa-solid fa-heart btn__icon"></i>Handicap Center Visit
                                        </span>
                                        <h1 className="sectionTitle__big text-center">Handicap Center Visit</h1>
                                        <p className='text-center' style={{ fontSize: '24px' }}>Memories of connecting with and supporting differently-abled individuals.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-40">
                                        <figure className="blogBlock__figure">
                                            {/* <Link to="#" */}
                                            {/* onClick={(e) => e.preventDefault()} className="blogBlock__figure__link"> */}
                                            <img src={q1} alt="Volunteers interacting with residents at the handicap center" className="blogBlock__figure__image" />
                                            {/* </Link> */}
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q2} alt="Children seated together during an activity at the handicap center" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q3} alt="Volunteers engaging with differently-abled children during the visit" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q4} width={400} loading='lazy' alt="Team members observing equipment at the handicap center." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q5} width={400} loading='lazy' alt="Volunteers meeting residents during the handicap center visit." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q6} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q7} width={400} loading='lazy' alt="Group with residents at the handicap center." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                </main>
                <Footer />
                <Scrollbar />
            </Fragment>
        </>
    )
};

export default HandicapCenterVisit;
